import React from "react";
import { Link } from "react-router-dom";
import { Film } from "lucide-react";
import AppLayout from "@/components/AppLayout";
import VideoLibrary from "@/components/VideoLibrary";

export default function StudentVideos() {
  return (
    <AppLayout variant="student">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sky-light text-sky-hover font-bold text-sm mb-2">
              <Film className="w-4 h-4" /> Lessons
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-ink">Watch & learn</h1>
            <p className="text-lg text-stone mt-1">Lesson videos from your teacher.</p>
          </div>
          <Link to="/student" data-testid="videos-back-link" className="text-sm font-bold text-stone hover:text-ink">← Dashboard</Link>
        </div>

        <VideoLibrary />
      </div>
    </AppLayout>
  );
}
